<template>
  <div
    class="sub-bottom-bar"
    :class="{'sub-bottom-bar--stack': navItems.length > 8}"
  >
    <transition name="fade">
      <div class="sub-bottom-bar__wrapper" v-show="navItems.length || activeNavItems.length">
        <transition-group
          class="sub-bottom-bar__nav-items"
          :class="[
            {'padding-level--0': navItems.length >= 15},
            {'padding-level--1': navItems.length < 15 && navItems.length >= 13},
            {'padding-level--2': navItems.length < 13 && navItems.length >= 11},
          ]"
          @before-enter="beforeEnter"
          @enter="enter"
          @afterEnter="afterEnter"
          @leave="leave"
        >     
          <div
            v-for="(navItem, index) in activeNavItems"
            class="sub-bottom-bar__nav-item-wrapper"
            :data-index="index"
            :key="navItem._id"
            :data-id="navItem._id"
          >
            <router-link
              class="btn touch"
              tag="button"
              :to="getItemUrl(navItem)"
              @click.native="triggerMedia(navItem.label['en']); playClickSound(); bus.$emit('navClick')"
              :dir="lang.rtl ? 'rtl' : 'ltr'"
            >
              <div v-if="navItem.icon && navItem.icon[1]" class="btn__icon">
                <fa :icon="navItem.icon"/>
              </div>
              <div
                
                v-html="navItem.label[lang.code] || navItem.label['en']"
                :style="`
                  margin: ${styles['sub-bottom-bar']['button']['label-offset']}
                `"
              ></div>
            </router-link>
          </div>
        </transition-group>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { bus } from '../main'
import _ from 'lodash'

export default {
  props: ['nav-items'],

  data () {
    return {
      activeNavItems: [],
      bus: bus
    }
  },

  computed: {
    ...mapGetters({
      activePage: 'activePage',
      lang: 'language',
      styles: 'styleTemplate'
    }),

    buttonStyles () {
      return {}
      // return {
      //   color: this.styles['sub-bottom-bar']['button']['color'],
      //   fontFamily: this.styles['sub-bottom-bar']['button']['font-family'],
      //   fontSize: this.styles['sub-bottom-bar']['button']['font-size'],
      //   fontWeight: this.styles['sub-bottom-bar']['button']['font-weight'],
      // }
    },

    buttonStylesActive () {
      return {}
      // return {
      //   color: this.styles['sub-bottom-bar']['button-active']['color'],
      //   fontFamily: this.styles['sub-bottom-bar']['button-active']['font-family'],
      //   fontSize: this.styles['sub-bottom-bar']['button']['font-size'],
      //   fontWeight: this.styles['sub-bottom-bar']['button']['font-weight'],
      // }
    },
  },

  watch: {
    navItems (newNavItems, oldNavItems) {
      if (!_.isEqual(oldNavItems, newNavItems)) {
        if (oldNavItems.length) {
          this.activeNavItems = []
        }

        if (newNavItems.length) {
          this.$store.commit('addAnimationToQueue', 'SubBottomBar')
        }
      }
    }
  },

  mounted () {
    bus.$on('animateSubBottomBar', () => {
      if (!_.isEqual(this.activeNavItems, this.navItems)) {
        setTimeout(() => {
          this.activeNavItems = this.navItems
        }, 300)
        
      } else {
        bus.$emit('finishedAnimation', 'SubBottomBar')
      }
    })
  },

  methods: {
    ...mapActions([
      'playClickSound'
    ]),

    beforeEnter (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
    },

    enter (el, done) {
      setTimeout(() => {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
        el.style.transition = `transform 0.6s cubic-bezier(0.33, 1, 0.68, 1), opacity 1.2s`
        done()
      }, (parseInt(el.dataset.index) + 1) * 150)
    },

    afterEnter (el) {
      if (parseInt(el.dataset.index) + 1 === this.navItems.length) {
        bus.$emit('finishedAnimation', 'SubBottomBar')
      }
    },    

    leave (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(25%)'
      el.style.transition = `transform 0.4s cubic-bezier(0.32, 0, 0.67, 0)`
    },

    getItemUrl (navItem) {
      if (navItem.customRoute) {
        return navItem.customRoute
      }

      if (navItem.pageId) {
        return /category/ + this.$store.state.route.params.categoryId + '/page/' + navItem.pageId
      }

      if (navItem.to) {
        return navItem.to
      }

      return ''
    },

    isNavItemActive (item) {
      const navEl = document.querySelector(`[data-id="${item._id}"]`)
      if (!navEl) return false
      return navEl.classList.contains('router-link-exact-active')
    },

    triggerMedia (pageName) {
      const formattedPageName = pageName.toLowerCase().replaceAll(' ', '-')
      this.$store.dispatch('triggerVideo', `${process.env.VUE_APP_PROJECT}_${formattedPageName}.mp4`)
    }
  },
}
</script>
<style lang="scss">
@import "@/styles/_mixins.scss";
@import "@/styles/_variables.scss";
@import "@/styles/_buttons.scss";

.padding-level {
  &--0 {
    padding: 0 5.5rem;
  }

  &--1 {
    padding: 0 14.5rem;
  }

  &--2 {
    padding: 0 24rem;
  }
}

.sub-bottom-bar {
  // background-color: rgba($black, 0.45);
  bottom: 10rem;
  left: 0;
  right: 32.5rem;
  height: 5rem;
  position: absolute;
  z-index: 200;

  .layout-switched & {
    bottom: initial;
    top: 10rem;
  }

  &--stack {
    height: 8rem;

    .sub-bottom-bar__nav-items {
      height: 7rem;
      margin-top: .5rem;
    }
  }

  &__wrapper {
    background-color: rgba($black, 0.45);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
    
  &__nav-items {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    height: 5rem;
    justify-content: center;

    // svg {
    //   margin-right: 1em;
    // }

    .btn {
      align-items: center;
      color: $white;
      display: flex;
      font-size: 1.1rem;
      font-weight: 300;
      height: 2.5rem;
      justify-content: center;
      // letter-spacing: .15rem;
      line-height: 0;
      margin: 0 .5rem;
      padding: .2rem .5rem 0;
      width: 17.5rem;

      &.router-link-exact-active {
        color: $black;
      }

      div {
        height: auto;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>